import { useEffect, useMemo, useState } from 'react';

function useIsInViewport(ref: React.MutableRefObject<null>, observe: boolean = true) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(() => new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting)), []);

  useEffect(() => {
    if (observe && ref.current) {
      observer.observe(ref.current);
    } else {
      observer.disconnect();
    }
    return () => {
      observer.disconnect();
    };
  }, [ref, observer, observe]);

  return isIntersecting;
}

export default useIsInViewport;
